import { registerLocaleData } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import localeNl from "@angular/common/locales/nl";
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Router, RouteReuseStrategy } from "@angular/router";
import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faTrello as fabTrello } from "@fortawesome/free-brands-svg-icons";
// Import entire Pro Light icon set for dynamic workflow status icons
import { fal } from "@fortawesome/pro-light-svg-icons";
import {
	faBoxAlt as farBoxAlt,
	faLockAlt as farLockAlt,
	faCarBuilding as farCardBuilding,
	faThumbsUp as farThumbsUp
} from "@fortawesome/pro-regular-svg-icons";
import {
	faArrowAltRight as fasArrowAltRight,
	faBroadcastTower as fasBroadcastTower,
	faCaretDown as fasCaretDown,
	faCaretLeft as fasCaretLeft,
	faCaretRight as fasCaretRight,
	faChartBar as fasChartBar,
	faCheck as fasCheck,
	faCheckCircle as fasCheckCircle,
	faEnvelope as fasEnvelope,
	faEnvelopeOpen as fasEnvelopeOpen,
	faEuroSign as fasEuroSign,
	faExclamationCircle as fasExclamationCircle,
	faExclamationTriangle as fasExclamationTriangle,
	faFilter as fasFilter,
	faInfoCircle as fasInfoCircle,
	faLink as fasLink,
	faPaperPlane as fasPaperPlane,
	faPhone as fasPhone,
	faPlus as fasPlus,
	faPlusCircle as fasPlusCircle,
	faQuestionCircle as fasQuestionCircle,
	faStar as fasStar,
	faTimesCircle as fasTimesCircle,
	faTrashAlt as fasTrashAlt,
	faTrashUndoAlt as fasTrashUndoAlt,
	faUndo as fasUndo,
	faUnlink as fasUnlink,
	faLightbulbSlash as fasLightbulbSlash,
	faLightbulbOn as fasLightbulbOn,
	faChevronRight as fasChevronRight,
	faChevronLeft as fasChevronLeft,
	faChevronDoubleLeft as fasChevronDoubleLeft,
	faChevronDoubleRight as fasChevronDoubleRight,
	faMoon as fasMoon,
	faEclipseAlt as fasEclipseAlt,
	faQuestion as fasQuestion,
	faExternalLinkAlt as fasExternalLinkAlt,
	faThumbsUp as fasThumbsUp
} from "@fortawesome/pro-solid-svg-icons";
// import { AppVersion } from "@ionic-native/app-version/ngx";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";

import { initApp } from "./app-initializer";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { AuthService } from "./core/services/auth.service";
import { EnvironmentService } from "./core/services/environment.service";
import { LoadingService } from "./core/services/loading.service";
import { StorageService } from "./core/services/storage.service";
import { ToastService } from "./core/services/toast.service";
import { SharedModule } from "./shared/shared.module";

registerLocaleData(localeNl, "nl");

// SENTRY
import * as SentryAngular from "@sentry/angular";

@NgModule({
	providers: [
		// AppVersion,
		{
			deps: [AuthService, EnvironmentService, LoadingService, ToastService, StorageService, HttpClient, SentryAngular.TraceService],
			multi: true,
			provide: APP_INITIALIZER,
			useFactory: initApp
		},
		{
			provide: LOCALE_ID,
			useValue: "nl-NL"
		},
		{
			provide: RouteReuseStrategy,
			useClass: IonicRouteStrategy
		},
		{
			provide: ErrorHandler,
			// Attach the Sentry ErrorHandler
			useValue: SentryAngular.createErrorHandler()
		},
		{
			provide: SentryAngular.TraceService,
			deps: [Router]
		}
	],
	declarations: [AppComponent],
	imports: [
		AppRoutingModule,
		BrowserModule,
		CoreModule,
		FontAwesomeModule,
		HttpClientModule,
		IonicModule.forRoot({ backButtonText: "", innerHTMLTemplatesEnabled: true }),
		SharedModule
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(private faIconLibrary: FaIconLibrary) {
		// Register entire Pro Light icon library for dynamic workflow status icons
		// This allows users to create custom workflow statuses with any Pro Light icon
		this.faIconLibrary.addIconPacks(fal);

		// Register additional icon styles (solid, regular, brands)
		this.faIconLibrary.addIcons(
			// Solid icons
			fasLightbulbSlash,
			fasLightbulbOn,
			fasArrowAltRight,
			fasCaretDown,
			fasCaretLeft,
			fasCaretRight,
			fasChartBar,
			fasCheck,
			fasCheckCircle,
			fasEnvelope,
			fasEnvelopeOpen,
			fasExclamationTriangle,
			fasExclamationCircle,
			fasFilter,
			fasInfoCircle,
			fasPaperPlane,
			fasPhone,
			fasPlus,
			fasQuestionCircle,
			fasStar,
			fasTimesCircle,
			fasTrashAlt,
			fasTrashUndoAlt,
			fasUndo,
			fasUnlink,
			fasLink,
			fasChevronRight,
			fasChevronLeft,
			fasChevronDoubleLeft,
			fasChevronDoubleRight,
			fasMoon,
			fasEclipseAlt,
			fasPlusCircle,
			fasQuestion,
			fasBroadcastTower,
			fasEuroSign,
			fasThumbsUp,
			fasExternalLinkAlt,
			// Regular icons
			farLockAlt,
			farBoxAlt,
			farCardBuilding,
			farThumbsUp,
			// Brand icons
			fabTrello
		);
	}
}
